export const MESSAGE_BODY_AVAILABILITIES = ["available", "deletedFromMailbox"];
//# sourceMappingURL=user-mailbox.js.map